import { z } from "zod/v4";
import { ValidateInputPhoneNumber } from "@/app/infrastructures/misc/common-library/ValidateInputPhoneNumber";

export const senderCountrySchema = z
  .string()
  .nonempty("bookingV4.sender.country.error.required");

export const senderNameSchema = z
  .string()
  .nonempty("bookingV4.sender.name.error.required")
  .min(3, "bookingV4.sender.name.error.minLength");

export const senderPhoneSchema = z
  .string()
  .nonempty("bookingV4.sender.phone.error.required")
  .min(5, "bookingV4.sender.phone.error.invalid")
  .refine((phone) => ValidateInputPhoneNumber(phone).success, {
    message: "bookingV4.sender.phone.error.invalid"
  });

const senderAddressSchema = z
  .string()
  .nonempty("bookingV4.sender.address.error.required")
  .min(3, "bookingV4.sender.address.error.minLength");

export const senderReceiverAddressSchema = z
  .object({
    addressSender: senderAddressSchema,
    addressReceiver: senderAddressSchema
  })
  .refine(
    (data) =>
      data.addressSender.trim().toLowerCase() !==
      data.addressReceiver.trim().toLowerCase(),
    {
      message: "bookingV4.sender.address.error.sameAddress",
      path: ["addressSender"]
    }
  );
